import {EntityState} from '@reduxjs/toolkit';

const plainValue = (value: unknown): unknown => {
    if (value == null || typeof value !== 'object') return value;
    if (value instanceof Date) return value.toISOString();
    if (Array.isArray(value)) return value.map((item) => plainValue(item));
    const proto = Object.getPrototypeOf(value);
    if (proto !== Object.prototype && proto !== null) return undefined;
    const out: Record<string, unknown> = {};
    Object.keys(value as object).sort().forEach((key) => {
        if (key === 'nkObject') return;
        const next = plainValue((value as Record<string, unknown>)[key]);
        if (next !== undefined) out[key] = next;
    });
    return out;
};

// Kotlin instances are a new object on every fetch. Compare the plain fields the
// screens render, and drop nkObject and other host objects instead of stringifying them.
const entitySignature = (entity: unknown): string => JSON.stringify(plainValue(entity));

export const sameEntityList = <T extends { id: string | number }>(current: EntityState<T>, items: T[]): boolean => {
    if (current.ids.length !== items.length) return false;
    try {
        return items.every((item) => {
            const existing = current.entities[item.id];
            return existing !== undefined && entitySignature(existing) === entitySignature(item);
        });
    } catch {
        return false;
    }
};

/** A successful empty response replaces a list that already has rows. It does not churn an empty list. */
export const shouldApplyRefreshList = (currentCount: number, nextCount: number, changed: boolean): boolean => {
    if (!changed) return false;
    if (nextCount === 0) return currentCount > 0;
    return true;
};
